import React from 'react'
import './headerDetails.css'
import { HEADER_DETAILS_KEYS } from '../../utils/translation-constants'
import { useTranslation } from 'react-i18next';

export default function BlockCardHeaderDetails({ option = {} }) {
  const {t}=useTranslation()
  return (
    <div className='approval-card-header '>
      <span>
      <span className='span1'>{t(HEADER_DETAILS_KEYS.ACCOUNT_NO)}. : {option?.srcAccount}</span>
        <span className='mt-2 span2'>{option?.srcAccCcy}</span>
      </span>
    </div>
  )
}
